// Poulpe's arms, the one sign of work in progress, moved from today's pages
// (components/Working.tsx there) with the sizes the transcript draws: four
// arms in a line of text, or small. styles/working.css draws them.
import type { AriaAttributes } from 'react'

export type WorkingSize = 'inline' | 'small'

/** Poulpe's arms: the same colours for every kind of work. */
export function Working({
  label = 'Loading',
  visibleLabel = false,
  size = 'inline',
  'aria-hidden': hidden,
}: {
  label?: string
  visibleLabel?: boolean
  size?: WorkingSize
  'aria-hidden'?: AriaAttributes['aria-hidden']
}) {
  const arms = (
    <span
      className={`pp-arms pp-arms--loader pp-arms--${size}`}
      role={visibleLabel ? undefined : 'img'}
      aria-label={visibleLabel ? undefined : label}
      aria-hidden={visibleLabel ? true : hidden}
    >
      {Array.from({ length: 4 }, (_, arm) => (
        <i key={arm} />
      ))}
    </span>
  )
  return visibleLabel ? (
    <span className="pp-loading" role="status" aria-hidden={hidden}>
      {arms}
      {label}
    </span>
  ) : (
    arms
  )
}
